import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import themeReducer from './themeSlice';
import competitionReducer from './competitionSlice';
import { logger } from 'redux-logger';

const rootReducer = {
  theme: themeReducer,
  competition: competitionReducer
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['competition'],
  debug: true // Add this for debugging
};

const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST', 
          'persist/REHYDRATE',
          // Add these to ignore date serialization during form updates
          'competition/updateCompetition',
          'competition/addCompetition'
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'competition.currentCompetition.competition.startDate',
          'competition.currentCompetition.competition.endDate'
        ]
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools
});

// Add a store subscription to log state changes
store.subscribe(() => {
  // console.log('Store updated:', store.getState());
});

export const persistor = persistStore(store);
